import { ArrowBackUpIcon, EmailIcon, TgIcon, VibrateIcon } from '@/assets/icons';
import { SettingsItem } from './components/settings-item';
import { dataSettingsRoutes } from './data-settings-routes';
import styles from './settings-list.module.scss';
import { Typography } from '@/ui-kit';
import { useEffect, useState } from 'react';
import { useVibration } from '@/store/useVibration';
// @ts-ignore
import Switch from 'react-ios-switch';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { routesApp } from '@/constans/routes';
import { useAuth } from '@/store/useAuth';

export const SettingsList = () => {
    const { isVibrationEnabled, setVibrationEnabled } =
        useVibration(state => state);

    const { t } = useTranslation();

    const { user } = useAuth(state => state)

    const hasTg = user?.tgid_confirmed

    const hasEmail = user?.email_confirmed

    return (
        <div className={styles.settingsList}>
            {dataSettingsRoutes.map((item) => {
                const IconComponent = item.icon;
                return (
                    <SettingsItem
                        key={item.value}
                        path={item.path}
                        icon={
                            <IconComponent width={28} height={28} />
                        }
                        title={t(item.translationKey)} />
                );
            })}
            <div className={styles.settingsItemAction}>
                <VibrateIcon width={28} height={28} />
                <Typography
                    className={styles.settingsItemActionText}
                    typeColor="black"
                    fontFamily="SFProText">
                    {t('profile.sounds_and_notifications')}
                </Typography>
                <Switch
                    className={styles.settingsItemActionTrailing}
                    checked={isVibrationEnabled}
                    handleColor="#fff"
                    offColor="#E5E5EA"
                    onColor="#F26A1C"
                    style={{
                        minWidth: '50px'
                    }}
                    onChange={async (checked: boolean) => {
                        setVibrationEnabled(checked)
                        localStorage.setItem('VIBRATION_ENABLED', checked.toString())
                    }} />
            </div>
            <div className={styles.settingsItemLinking}>
                <TgIcon
                    width={24}
                    height={24}
                    className={clsx(hasTg && styles.settingsItemLinkingIconActive)} />
                <div className={styles.settingsItemLinkingMain}>
                    <Typography
                        className={styles.settingsItemLinkingMainTitle}
                        typeColor="black"
                        fontFamily="SFProText">
                        {t('profile.telegram')}
                    </Typography>
                    <Typography typeColor="gray-label" fontFamily="SFProText">
                        {t(`profile.${hasTg ? 'linked' : 'unlinked'}`)}
                    </Typography>
                </div>
                <ArrowBackUpIcon
                    width={12}
                    height={16}
                    className={styles.settingsItemLinkingTrailing} />
            </div>
            <Link className={styles.settingsItemLinking} to={routesApp.setEmail}>
                <EmailIcon
                    width={24}
                    height={24}
                    className={clsx(hasEmail && styles.settingsItemLinkingIconActive)} />
                <div className={styles.settingsItemLinkingMain}>
                    <Typography
                        className={styles.settingsItemLinkingMainTitle}
                        typeColor="black"
                        fontFamily="SFProText">
                        {t('profile.email')}
                    </Typography>
                    <Typography typeColor="gray-label" fontFamily="SFProText">
                        {hasEmail ? user.email : t('profile.unlinked')}
                    </Typography>
                </div>
                <ArrowBackUpIcon
                    width={12}
                    height={16}
                    className={styles.settingsItemLinkingTrailing} />
            </Link>
        </div>
    );
};
